const navigationBar = {
  titles: {
    equipmentList: "Assets List",
    assets: "Operations",
    area: "Area List",
    worksModule: "WPC",
    stocks: "Inventory",
    calendar: "Calendar",
    support: "Technical Support",
    userProfile: "User Profile",
    CAO: "WPC"
  },
  inspectionList: "Operations Inspections List",
  repairList: "Repair Logs List",
  new: "New",
  equipment: "Asset",
  equipmentType: "Asset Type",
  user: "User",
  logs: "Alerts",
  customer: "Customer",
  unit: "Unit",
  reliability: "Reliability Inspections  ",
  plant: "Facility",
  company: "Company Structure",
  area: "Area",
  sealTypes: "Seal Types",
  hazardous: "Hazardous Area",
  userList: "User List",
  signOut: "Sign Out",
  module: "Modules",
  dashboard: "Home"
};
export default navigationBar;
